import { atual } from '@/session/sessao';

/**
 * A clínica que a tela está vendo, para as funções de borda saberem qual.
 *
 * Não é autorização: a borda confere contra o TOKEN (`acesso_a_clinica()`), e
 * clínica que o token não alcança é recusada. Numa impersonação vai a clínica
 * impersonada — e a borda recusa o que escreve ou gasta por ela. Sem clínica
 * nenhuma (operador no painel), não vai nada.
 */
export function clinicaAtiva(): string | undefined {
    const sessao = atual();
    return sessao?.clinicaId ?? sessao?.impersonando?.clinicaId ?? undefined;
}
